<script setup>
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

const props = defineProps({
    year: String,
    bookingById: Object,
    agent: Object,
    user: Object,
});
dayjs.extend(advancedFormat);

function getAdultChildInfant(clients) {
    let adult = 0;
    let child = 0;
    let infant = 0;
    clients.forEach((client) => {
        if (client.dob == null) {
            adult++;
        } else if (dayjs().diff(client.dob, 'year') < 2) {
            infant++;
        } else {
            child++;
        }
    });
    return 'Adults: ' + adult + ' / Children: ' + child + ' / Infants:' + infant;
}

//function to make first letter capital
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


</script>
<template>

    <div class="row invoice-preview">
        <!-- Invoice -->
        <div class="col-xl-9 col-md-8 col-12 mb-md-0 mb-4">
            <div class="card invoice-preview-card">
                <div class="card-body pb-0 pt-0">
                    <div
                        class="d-flex justify-content-between flex-xl-row flex-md-column flex-sm-row flex-column p-sm-3">
                        <div class="d-flex svg-illustration">
                            <span class="app-brand-logo">
                                <img style="width:200px;" v-if="$page.props.user.user_type == 'Company'"
                                    :src="'/storage/company_logos/' + props.agent?.logo" alt="logo">
                                <img style="width:200px;" v-else
                                    :src="'/storage/company_logos/' + props.agent?.agent_logo" alt="logo">
                            </span>
                        </div>
                        <div class="pt-3">
                            <h4>Hotel Voucher</h4>
                            <div class="mb-3">
                                <span class="me-1">Booking No: {{ bookingById.booking_no }}</span>
                            </div>
                            <div>
                                <span class="fw-semibold">
                                    {{ dayjs().format('Do MMMM YYYY') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="my-0" />
                <div class="card-body pt-0 pb-0">
                    <div class="row p-sm-2 p-0">
                        <div class="col-12"
                            style="background:#efefef;padding-left:15px;padding-bottom:10px;padding-top:10px;">
                            <div class="row">
                                <div>
                                    <td class="pe-3"><strong>Property Name: </strong></td>
                                    <td> {{ bookingById.hotel.name }}</td>
                                </div>
                                <div>
                                    <span class="pe-3"><strong>Confirmation Ref: </strong></span>
                                    <span style="width:10px;"> {{ bookingById.resort_confirmation_number }}</span>
                                </div>
                                <div>
                                    <td class="pe-3"><strong>Booking Number: </strong></td>
                                    <td><b> {{ bookingById.booking_no }}</b></td>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-6 col-md-12 col-sm-5 col-12"
                            style="background-color: #e1f5fe; border-radius:4px; padding-top:10px; padding-left:15px; padding-bottom:10px; margin-top: 4px; margin-bottom: 4px;">
                            <table>
                                <tbody>
                                    <tr>
                                        <td class="pe-3"><strong>Check in:</strong></td>
                                        <td>{{ dayjs(bookingById.arrival_date).format('ddd, Do MMMM YYYY') }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Room Type:</strong></td>
                                        <td>
                                            <span v-for="roomtype in bookingById.booking_rooms" :key="roomtype.id">
                                                <span>{{ roomtype.room_category?.name }} <b>For</b> {{ roomtype.nights
                                                }}
                                                    Nights </span>
                                            </span>
                                            <span v-if="bookingById.stay_type == 1"> <b>(Split Stay)</b></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Arrival Info:</strong></td>
                                        <td>{{ bookingById.arrival_flight }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Arrival Transfer:</strong></td>
                                        <td>{{ bookingById.transfers[0]?.vessel }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Nationality:</strong></td>
                                        <td>{{ bookingById.countries[0]?.name }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Offer Code:</strong></td>
                                        <td>{{ bookingById.offer_code }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-xl-6 col-md-12 col-sm-7 col-12"
                            style="background-color: #e1f5fe; border-radius:4px; padding-top:6px; padding-left:15px; padding-bottom:10px; margin-top: 4px; margin-bottom: 4px;">
                            <table>
                                <tbody>
                                    <tr>
                                        <td class="pe-3"><strong>Check out:</strong></td>
                                        <td>{{ dayjs(bookingById.departure_date).format('ddd, Do MMMM YYYY') }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Meal Plan:</strong></td>
                                        <td>{{ bookingById.meal_type }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>No. of Rooms:</strong></td>
                                        <td>{{ bookingById.no_rooms }} Room</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Departure Info:</strong></td>
                                        <td>{{ bookingById.departure_flight }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Departure Transfer:</strong></td>
                                        <td>{{ bookingById.transfers[1]?.vessel }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>No. of Guests:</strong></td>
                                        <td>{{ getAdultChildInfant(bookingById?.client) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-12"
                            style="background:#efefef;padding-left:15px;padding-bottom:10px;padding-top:10px;">
                            <div class="col-md-6" style="padding-right:1;">
                                <b>Guest Names:</b>
                            </div>
                            <div class="col-md-6" style="padding-left:0;">
                                <span v-for="clients in bookingById?.client" :key="clients.id">
                                    {{ capitalizeFirstLetter(clients.title) + '. ' +
                                            capitalizeFirstLetter(clients.first_name) + ' ' +
                                            capitalizeFirstLetter(clients.last_name)
                                    }} <b>in Room</b> {{ clients.room_no }}<br>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive pb-0">
                    <table class="table border-top m-0">
                        <tbody>
                            <tr valign=top>
                                <td colspan="2" class="align-top px-4 py-3" style="line-height:5px;">
                                    <p class="mb-3 col-md-6">
                                        <span class="me-1 fw-semibold">Airport Contact</span>
                                    </p>
                                    <span v-if="$page.props.user.user_type == 'Company'"
                                        v-html="props.agent?.airport_contact"></span>
                                    <span v-else v-html="props.agent?.airport_contact"></span>
                                </td>
                                <td class="text-end px-4 py-3">
                                    <p class="mb-2 fw-semibold">Special Requests: </p>
                                </td>
                                <td class="px-4 py-3" style="font-size: 14px;">
                                    <p class="mb-2" v-html="bookingById.remarks"></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div align="center">
                    <table>
                        <tbody>
                            <tr style="font-size: 12px;">
                                <td colspan="4" align="center" style="padding: 9px;">
                                    <span v-if="$page.props.user.user_type == 'Company'"
                                        v-html="props.agent?.address2"></span>
                                    <span v-else v-html="props.agent?.agency_address"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template >